<template>
  <div>
    <div class="banner" v-if="hasWorks === true">
      <div class="banner-bg">
        <h5>作品平均分</h5>
        <rate
          :value="averageScore"
          disabled
          void-color="#e3feff"
          text-color="#ffe600"
        />
        <p>
          超过了
          <span class="bold">{{averageOver}}</span>的同学
        </p>
      </div>
    </div>
    <div class="content" v-if="hasWorks === true">
      <ul>
        <li class="work" v-if="bestWorks">
          <h2>最佳作品</h2>
          <div
            class="flex"
            @click="$router.push({name: 'workDetail', query: {id: bestWorks.id}})"
          >
            <div
              class="cover"
              :style="{backgroundImage: `url(${bestWorks.preview_url})`}"
            ></div>
            <div>
              <h5>{{bestWorks.name}}</h5>
              <p>{{bestWorks.created_at | date('Y-m-d')}}</p>
              <div class="flex">总分：
                <rate
                  :value="bestWorks.total_score"
                  disabled
                  void-color="#e3feff"
                  text-color="#ffe600"
                />
              </div>
            </div>
          </div>
        </li>
        <li class="work-chart">
          <h2>作品统计图</h2>
          <div>
            <bus-pie-charts v-if="semesteWorks" :data="semesteWorks"></bus-pie-charts>
          </div>
        </li>
        <li class="skill-chart">
          <h2>编程能力维度分析图表</h2>
          <div>
            <bus-radar-charts v-if="radarData" :data="radarData"></bus-radar-charts>
          </div>
        </li>
      </ul>
    </div>
    <div class="no-works" v-if="hasWorks === false">
      <no-work-img/>
      <p>暂无数据</p>
    </div>
  </div>
</template>
<script>
import PieCharts from '@/components/PieCharts'
import BusPieCharts from '@/widgets/BusPieCharts'
import RadarCharts from '@/components/RadarCharts'
import BusRadarCharts from '@/widgets/BusRadarCharts'
import NoWorkImg from '@/assets/svg/no_works.svg'
import { Rate } from 'element-ui'
import { get } from '@/utils/ajax'
export default {
  name: 'WorkReport',
  created() {
    this.refresh()
  },
  data() {
    return {
      hasWorks: true,
      bestWorks: null,
      workData: null,
      semesteWorks: null, // 作品统计图
      radarData: null, // 编程能力雷达图
      averageScore: 0,
      averageOver: '--'
    }
  },
  methods: {
    async refresh() {
      const res = await get('/edu/wap/works/achievement')
      if (res.total > 0) {
        this.hasWorks = true
        this.semesteWorks = res
        this.getBestWorks()
        this.getRadarData()
        this.getAverage()
      } else {
        this.hasWorks = false
      }
    },
    async getBestWorks() {
      const res = await get('/edu/wap/works/optimum')
      if (!res) {
        this.bestWorks = null
      } else {
        res.total_score = (res.total_score / 100) * 5
        this.bestWorks = res
      }
    },
    async getRadarData() {
      this.radarData = await get('/edu/wap/works/dimension')
    },
    async getAverage() {
      const res = await get('/edu/wap/works/average')
      this.averageOver = res.over + '%'
      this.averageScore = (res.average_score / 100) * 5
    }
  },
  components: {
    Rate,
    NoWorkImg,
    RadarCharts,
    BusRadarCharts,
    PieCharts,
    BusPieCharts
  }
}
</script>
<style lang="stylus" scoped>
.banner, .work
  >>> .el-rate__icon
    font-size 16px
    margin-right 2px
.banner
  margin-top 10px
  padding-right 15px
  padding-left 15px
  .bold
    font-weight bold
    vertical-align middle
  h5
    color white
    font-size 14px
  span
    color #FFE600
    font-size 24px
    margin-right 10px
    margin-left 10px
  .banner-bg
    flex-column-center()
    color white
    height 140px
    border-radius 6px
    box-shadow 0 4px 12px 0 #92CFFB
    background-fit('~@/assets/images/report_banner')
.no-works
  margin-top 87px
  text-align center
  p
    margin-top -50px
  svg
    width 240px
    // height 183px
.content
  padding-bottom 44px
  >>> .charts
    height 250px !important
  li
    border-bottom 10px solid #f4f4f4
    padding 30px 15px 0 15px
  h2
    font-weight normal
    font-size 16px
    color #333333
    &:before
      content ''
      width 3px
      height 14px
      display inline-block
      margin-right 8px
      background-color $themeColor
  .skill-chart
    padding-bottom 20px
  .work
    > div
      margin-bottom 30px
    h5
      color #333
      font-size 16px
      margin-bottom 10px
    .cover
      margin-left 15px
      margin-right 15px
      width 80px
      height 80px
      border-radius 4px
      background-cover()
      background-color #ccc
</style>
